module.exports = __webpack_public_path__ + "static/media/23.f38488f2.jpg";